<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                            <!-- Sección Izquierda (Título) -->
                            <div>
                                <h6 class="mb-2 ms-2">Horas Ptes. de Autorización</h6>
                            </div>

                            <div class="text-center">
                                <h4 class="mb-0"><b>{{ formatRangeLabel2(weekStartDate, weekEndDate) }}</b></h4>
                            </div>

                            <div>
                                <button v-if="selectedUsersToAuth.length > 0" @click="authSelectedUsers"
                                    class="btn btn-success mb-0">
                                    <i class="fas fa-check me-2"></i>
                                    Autorizar Selección ({{ selectedUsersToAuth.length }})
                                </button>
                                <button v-if="selectedUsersToAuth.length === 0" class="btn btn-success mb-0"
                                    @click="authAllRecords" :disabled="noRecords">
                                    <i class="fas fa-check me-2"> </i>Autorizar todo</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div>
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <button
                                        class="btn btn-warning d-flex align-items-center justify-content-center gap-2 mb-0"
                                        @click="changeWeek(-1)">
                                        <span class="ni ni-bold-left"> </span> Semana Anterior
                                    </button>
                                </div>

                                <div>
                                    <input type="text" class="form-control" placeholder="Buscar colaborador..."
                                        v-model="noAuthSearchQuery">
                                </div>

                                <div>
                                    <button
                                        class="btn btn-warning d-flex align-items-center justify-content-center gap-2 mb-0"
                                        @click="changeWeek(1)">
                                        Semana Siguiente <span class="ni ni-bold-right"> </span>
                                    </button>
                                </div>

                            </div>
                            <div class="table-container">
                                <table class="table table-bordered text-center align-middle">
                                    <thead class="sticky-header">
                                        <tr>
                                            <th></th>
                                            <th rowspan="2">Colaborador</th>
                                            <th colspan="3"><b>Resumen Horas</b></th>
                                            <th rowspan="2">Acciones</th>
                                            <th v-for="day in weekDays" :key="day.key" colspan="2">
                                                {{ day.label }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>
                                                <input type="checkbox" @change="toggleSelectAll"
                                                    :checked="allUsersToAuthSelected"
                                                    class="form-check-input border border-secondary">
                                            </th>
                                            <th>Total</th>
                                            <th>Regulares</th>
                                            <th>Extra</th>
                                            <template v-for="day in weekDays" :key="day.key">
                                                <th class="p-1 text-nowrap">HR</th>
                                                <th class="p-1 text-nowrap">HE</th>
                                            </template>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(employee, idx) in filteredEmployees" :key="idx">
                                            <td>
                                                <input type="checkbox" :value="employee.user_id"
                                                    v-model="selectedUsersToAuth"
                                                    class="form-check-input border border-secondary">
                                            </td>
                                            <td>
                                                {{ employee.name }}
                                                <span v-if="employee.pm_auth_days > 0" class="badge bg-info ms-1"
                                                    :title="`${employee.pm_auth_days} día(s) autorizados por PM`">
                                                    <i class="bi bi-shield-check"></i> PM
                                                </span>
                                            </td>
                                            <td><b>{{ employee.total_hours }} hrs</b></td>
                                            <td><b>{{ employee.regular_hours }}</b></td>
                                            <td><b>{{ employee.extra_hours }}</b></td>
                                            <td>
                                                <button @click="showUserDetails(employee.user_id, employee.name)"
                                                    class="btn btn-secondary mb-0">
                                                    <i class="bi bi-info-circle"></i>
                                                </button>
                                                <button @click="authRecordsByUser(employee.user_id)"
                                                    class="btn btn-success mb-0 ms-2">
                                                    <i class="fas fa-check"> </i>
                                                </button>
                                            </td>
                                            <template v-for="day in weekDays" :key="day.key">
                                                <td class="p-1 text-nowrap" :class="{
                                                    'justified-absence': employee.hours[day.key]?.justified_absence,
                                                    'pm-authorized': employee.hours[day.key]?.has_pm_auth
                                                }">
                                                    {{ employee.hours[day.key]?.hn ?? 0 }}
                                                </td>
                                                <td class="p-1 text-nowrap" :class="{
                                                    'justified-absence': employee.hours[day.key]?.justified_absence,
                                                    'pm-authorized': employee.hours[day.key]?.has_pm_auth
                                                }">
                                                    {{ employee.hours[day.key]?.he ?? 0 }}
                                                </td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-7">
                        <div class="card mt-4">
                            <div class="p-3 pb-0 card-header">
                                <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                                    <div>
                                        <h6 class="mb-2 ms-2">Colaboradores que NO han enviado horas:</h6>
                                    </div>
                                    <div v-if="!noNTE">
                                        <input type="text" class="form-control" placeholder="Bucar colaborador..."
                                            v-model="nteSearchQuery">
                                    </div>
                                    <div v-if="selectedUsers.length > 0">
                                        <button
                                            class="btn btn-secondary d-flex align-items-center justify-content-center gap-2 mb-0"
                                            @click="sendMultipleReminder">
                                            Enviar a seleccionados <i class="ni ni-send text-sm"></i>
                                        </button>
                                    </div>
                                    <div v-if="!noNTE && !selectedUsers.length > 0">
                                        <button
                                            class="btn btn-danger d-flex align-items-center justify-content-center gap-2 mb-0"
                                            @click="sendMultipleReminder" :disabled="noNTE">
                                            Enviar a todos <i class="ni ni-send text-sm"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table table-bordered text-center align-middle">
                                        <thead>
                                            <th></th>
                                            <th>Equipo</th>
                                            <th>Nombre</th>
                                            <th>Acciones</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(user, idx) in paginatedNTE" :key="idx">
                                                <td>
                                                    <input type="checkbox"
                                                        class="form-check-input border border-secondary"
                                                        :value="user.user_id" v-model="selectedUsers" />
                                                </td>
                                                <td>{{ user.team }}</td>
                                                <td><b>{{ user.name }} {{ user.last_name }}</b></td>
                                                <td>
                                                    <button class="btn btn-warning mb-0"
                                                        @click="sendReminder(user.user_id, user.name, user.last_name)">
                                                        <i class="ni ni-send text-sm"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-if="noNTE" class="d-flex justify-content-center">
                                        No hay registros disponibles para el periodo de tiempo seleccionado.
                                    </div>
                                    <!-- Controles de paginación -->
                                    <nav>
                                        <ul class="pagination justify-content-center">
                                            <li class="page-item" :class="{ disabled: currentPageNTE === 1 }">
                                                <button class="page-link" @click="changePageNTE(currentPageNTE - 1)">
                                                    <i class="ni ni-bold-left text-sm"></i>
                                                </button>
                                            </li>

                                            <li class="page-item" v-for="page in totalPagesNTE" :key="page"
                                                :class="{ active: currentPageNTE === page }">
                                                <button class="page-link bg-warning text-white"
                                                    @click="changePageNTE(page)">{{
                                                        page
                                                    }}</button>
                                            </li>

                                            <li class="page-item"
                                                :class="{ disabled: currentPageNTE === totalPagesNTE }">
                                                <button class="page-link" @click="changePageNTE(currentPageNTE + 1)">
                                                    <i class="ni ni-bold-right text-sm"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="card mt-4">
                            <div class="p-3 pb-0 card-header">
                                <div class="d-flex flex-column flex-md-row justify-content-between">
                                    <div>
                                        <h6 class="mb-2 ms-2">Mis colaboradores:</h6>
                                    </div>
                                    <div>
                                        <input type="text" class="form-control" placeholder="Buscar colaborador..."
                                            v-model="myUsersSearchQuery">
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table table-bordered text-center align-middle">
                                        <thead>
                                            <th>Nombre</th>
                                            <th>Acciones</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(usr, idx) in paginatedMU" :key="idx">
                                                <td>
                                                    {{ usr.name }} {{ usr.last_name }}
                                                </td>
                                                <td>
                                                    <button class="btn btn-danger mb-0"
                                                        @click="removeUser(usr.user_id)">
                                                        Remover</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-if="noUsers" class="d-flex justify-content-center">
                                        No tienes colaboradores asignados para autorizar.
                                    </div>
                                    <!-- Controles de paginación -->
                                    <nav>
                                        <ul class="pagination justify-content-center">
                                            <li class="page-item" :class="{ disabled: currentPageMU === 1 }">
                                                <button class="page-link" @click="changePageMU(currentPageMU - 1)">
                                                    <i class="ni ni-bold-left text-sm"></i>
                                                </button>
                                            </li>

                                            <li class="page-item" v-for="page in totalPagesMU" :key="page"
                                                :class="{ active: currentPageMU === page }">
                                                <button class="page-link bg-warning text-white"
                                                    @click="changePageMU(page)">{{
                                                        page
                                                    }}</button>
                                            </li>

                                            <li class="page-item" :class="{ disabled: currentPageMU === totalPagesMU }">
                                                <button class="page-link" @click="changePageMU(currentPageMU + 1)">
                                                    <i class="ni ni-bold-right text-sm"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card  mt-4">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                            <div>
                                <h6 class="ms-2">Horas Autorizadas</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div>
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h5 class="mb-0">Semana: {{ formatRangeLabel2(weekStartDate, weekEndDate) }}</h5>
                                </div>
                                <div>
                                    <input type="text" class="form-control" placeholder="Buscar colaborador..."
                                        v-model="authEmployeesQuery">
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-bordered text-center align-middle">
                                    <thead>
                                        <tr>
                                            <th rowspan="2">Colaborador</th>
                                            <th colspan="3"><b>Resumen Horas</b></th>
                                            <th v-for="day in weekDays" :key="day.key" colspan="2">
                                                {{ day.label }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Total</th>
                                            <th>Regulares</th>
                                            <th>Extra</th>
                                            <template v-for="day in weekDays" :key="day.key">
                                                <th class="p-1 text-nowrap">HR</th>
                                                <th class="p-1 text-nowrap">HE</th>
                                            </template>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(employee, idx) in filteredAuthEmployees" :key="idx">
                                            <td>{{ employee.name }}</td>
                                            <td><b>{{ employee.total_hours }} hrs</b></td>
                                            <td><b>{{ employee.regular_hours }}</b></td>
                                            <td><b>{{ employee.extra_hours }}</b></td>
                                            <template v-for="day in weekDays" :key="day.key">
                                                <td class="p-1 text-nowrap">{{ employee.hours[day.key]?.hn ?? 0 }}</td>
                                                <td class="p-1 text-nowrap">{{ employee.hours[day.key]?.he ?? 0 }}</td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="noAuthRecords" class="d-flex justify-content-center">
                                    <b>No hay registros disponibles para el periodo de tiempo seleccionado.</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script setup>

import { ref, computed, onMounted, toRaw, watch } from "vue"
import { useRouter } from "vue-router";
import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

//Obtener info del token
import { jwtDecode } from "jwt-decode";

const decodedToken = ref({})

if (token) {
    try {
        decodedToken.value = jwtDecode(token);
    } catch (error) {
        console.error("Error al decodificar el token:", error);
    }
} else {
    console.log("No hay token en localStorage");
}

const nteSearchQuery = ref("")
const myUsersSearchQuery = ref("")
const authEmployeesQuery = ref("")

const myUsers = ref([])

const router = useRouter()

const selectedUsers = ref([])
const selectedUsersToAuth = ref([])

const allUsersToAuthSelected = computed(() => {
    return filteredEmployees.value.length > 0 &&
        selectedUsersToAuth.value.length === filteredEmployees.value.length
})

const toggleSelectAll = () => {
    if (allUsersToAuthSelected.value) {
        selectedUsersToAuth.value = []
    } else {
        selectedUsersToAuth.value = filteredEmployees.value.map(e => e.user_id)
    }
}


const authorizers = ref([])
const employees = ref([])
const auth_employees = ref([])

const noRecords = ref(true)
const noAuthRecords = ref(true)

const noAuthSearchQuery = ref("")

const nteLoaded = ref(false)
const noNTE = ref(true)
const noUsers = ref(false)

const noTimeEmployees = ref([])

const filteredEmployees = computed(() => {
    const query = noAuthSearchQuery.value.toLowerCase();
    return employees.value.filter(e =>
        (e.name?.toLowerCase().includes(query))
    );
});


const filteredNoTimeEmployees = computed(() => {
    const query = nteSearchQuery.value.toLowerCase();
    return noTimeEmployees.value.filter(e =>
        (e.name?.toLowerCase().includes(query) || e.last_name?.toLowerCase().includes(query))
    );
});

const filteredMyUsers = computed(() => {
    const query = myUsersSearchQuery.value.toLowerCase();
    return myUsers.value.filter(e =>
        (e.name?.toLowerCase().includes(query) || e.last_name?.toLowerCase().includes(query))
    );
});

const filteredAuthEmployees = computed(() => {
    const query = authEmployeesQuery.value.toLowerCase();
    return auth_employees.value.filter(e =>
        (e.name?.toLowerCase().includes(query))
    );
});

const usePagination = (data, itemsPerPage = 5) => {
    const currentPage = ref(1)
    const perPage = ref(itemsPerPage)

    // Total de páginas
    const totalPages = computed(() => {
        return Math.ceil(data.value.length / perPage.value)
    })

    // Datos de la página actual
    const paginatedData = computed(() => {
        const start = (currentPage.value - 1) * perPage.value
        const end = start + perPage.value
        return data.value.slice(start, end)
    })

    // Cambiar página
    const changePage = (page) => {
        if (page >= 1 && page <= totalPages.value) {
            currentPage.value = page
        }
    }

    // Resetear a la primera página cuando cambien los datos
    watch(data, () => {
        currentPage.value = 1
    })

    return {
        currentPage,
        perPage,
        totalPages,
        paginatedData,
        changePage
    }
}

// Paginación para la tabla (no time employees)
const {
    currentPage: currentPageNTE,
    totalPages: totalPagesNTE,
    paginatedData: paginatedNTE,
    changePage: changePageNTE
} = usePagination(filteredNoTimeEmployees, 10)

// Paginación para la tabla (no time employees)
const {
    currentPage: currentPageMU,
    totalPages: totalPagesMU,
    paginatedData: paginatedMU,
    changePage: changePageMU
} = usePagination(filteredMyUsers, 10)


// Zona horaria CDMX
const TIMEZONE = "America/Mexico_City"
// Base actual
const baseDate = ref(new Date(new Date().setDate(new Date().getDate() - 7)))

// Obtener fecha CDMX
function getCDMXDate(date = new Date()) {
    const utc = date.toLocaleString("en-US", { timeZone: "UTC" })
    return new Date(
        new Date(utc).toLocaleString("en-US", { timeZone: TIMEZONE })
    )
}

// Obtener lunes de la semana
function getWeekStart(date) {
    const d = new Date(date)
    const day = d.getDay()
    const diff = d.getDate() - ((day + 6) % 7) // Lunes = 1
    return new Date(d.setDate(diff))
}

function getMonday(date) {
    const d = new Date(date)
    const day = d.getDay()
    const diff = d.getDate() - day + (day === 0 ? -6 : 1) // Ajusta si es domingo
    d.setDate(diff)
    return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}


// Generar semana actual
const weekStartDate = computed(() => getWeekStart(getCDMXDate(baseDate.value)))

const weekDays = computed(() => {
    const days = []
    const labels = ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"]
    const start = getMonday(weekStartDate.value)

    for (let i = 0; i < 7; i++) {
        const date = new Date(start.getTime())
        date.setDate(start.getDate() + i)
        const key = date.toISOString().split("T")[0] // yyyy-mm-dd
        const label = `${labels[i]} ${date.toLocaleDateString("es-MX", {
            day: "2-digit",
            month: "2-digit",
        })}`
        days.push({ key, label, date })
    }
    return days
})

const weekEndDate = computed(() => {
    const d = new Date(weekStartDate.value)
    d.setDate(d.getDate() + 6)
    return d
})

function formatToLocalYMD(date) {
    return date.toLocaleDateString("sv-SE", { timeZone: "America/Mexico_City" });
}

const startDate = ref(formatToLocalYMD(weekStartDate.value));
const endDate = ref(formatToLocalYMD(weekEndDate.value));

// Cambiar semana
const changeWeek = (direction) => {
    const newDate = new Date(baseDate.value)
    newDate.setDate(newDate.getDate() + direction * 7)
    baseDate.value = newDate
    startDate.value = formatToLocalYMD(weekStartDate.value)
    endDate.value = formatToLocalYMD(weekEndDate.value)
    getNotAuthAbstract()
    getAuthAbstract()
    getNoTimeSentUsers()
}

// Rango de fechas en el título

function formatRangeLabel2(start, end) {
    const opciones = {
        weekday: "short",  // Día de la semana abreviado
        day: "numeric",    // Día del mes sin cero inicial
        month: "short"     // Mes abreviado
    }

    const startStr = start.toLocaleDateString("es-MX", opciones)
    const endStr = end.toLocaleDateString("es-MX", opciones)

    // Capitaliza la primera letra de cada palabra (por si toLocaleDateString devuelve en minúsculas)
    const capitalize = (str) => str.replace(/\b\w/g, c => c.toUpperCase())

    return `${capitalize(startStr)} - ${capitalize(endStr)}`
}


const getNoTimeSentUsers = async () => {
    const body = {
        start_date: startDate.value,
        end_date: endDate.value,
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/no-time-sent-users-by-auth`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {

            nteLoaded.value = true;
            noTimeEmployees.value = response.data;

            if (noTimeEmployees.value.length === 0) {
                noNTE.value = true
            } else { noNTE.value = false }

        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}


const getAuthorizers = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-authorizers`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            authorizers.value = response.data;
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

const getNotAuthAbstract = async () => {

    const body = { start_date: startDate.value, end_date: endDate.value }
    try {
        const response = await axios.post(`${API_BASE_URL}/get-week-abstract`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            employees.value = response.data.data
            if (employees.value.length === 0) { noRecords.value = true }
            else { noRecords.value = false }
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const getAuthAbstract = async () => {

    const body = { start_date: startDate.value, end_date: endDate.value }
    try {
        const response = await axios.post(`${API_BASE_URL}/get-week-abstract-auth`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            auth_employees.value = response.data.data
            if (auth_employees.value.length === 0) { noAuthRecords.value = true }
            else { noAuthRecords.value = false }
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const getMyUsers = async () => {

    const body = { auth_id: decodedToken.value.user_id }
    try {
        const response = await axios.post(`${API_BASE_URL}/get-users-by-auth`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200 && response.data) {
            myUsers.value = response.data
            if (myUsers.value.length === 0) { noUsers.value = true; }
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const showUserDetails = async (userId, userName) => {
    router.push({
        name: 'Autorizar Colaborador',
        query: {
            user_id: userId,
            start_date: startDate.value,
            end_date: endDate.value,
            name: userName
        }
    })
}

const authAllRecords = async () => {
    if (!confirm('¿Estás seguro de autorizar todos los registros? Esta acción NO puede deshacerse')) {
        return
    }
    const body = { start_date: startDate.value, end_date: endDate.value }
    try {
        const response = await axios.post(`${API_BASE_URL}/auth-all-week-records`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200 && response.data.msg) {
            alert(response.data.msg)
            getNotAuthAbstract()
            getAuthAbstract()
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

const authRecordsByUser = async (userId) => {
    const body = {
        user_id: userId,
        start_date: startDate.value,
        end_date: endDate.value
    }
    if (!confirm('¿Estás seguro de autorizar la semana completa del colaborador? Esta acción NO puede deshacerse')) {
        return
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/auth-week-by-user`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            alert('Registros del usuario autorizados')
            getNotAuthAbstract()
            getAuthAbstract()
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const authSelectedUsers = async () => {

    const body = {
        users: selectedUsersToAuth.value,
        start_date: startDate.value,
        end_date: endDate.value
    }

    if (!confirm('¿Estás seguro de autorizar la semana completa de los colaboradores seleccionados? Esta acción NO puede deshacerse')) {
        return;
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/auth-selected-users`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            alert('Registros autorizados')
            getNotAuthAbstract()
            getAuthAbstract()
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        alert('Lo sentimos, hubo un error al realizar la acción.')
        console.error('Error en la solicitud:', error);
    }

}

const sendReminder = async (userId, name, lastName) => {

    alert(`Recordatorio enviado a ${name} ${lastName}`)

    const body = {
        user_id: userId,
        start_date: startDate.value,
        end_date: endDate.value
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/send-time-reminder`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            console.log(response.data)
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const sendMultipleReminder = async () => {

    if (!confirm('¿Estás segur@ de enviar recordatorio a todos los colaboradores seleccionados?')) {
        return;
    }

    alert('Recordatorios Enviados')

    const body = {
        allUsers: true,
        userIds: [],
        start_date: startDate.value,
        end_date: endDate.value
    }

    if (selectedUsers.value.length > 0) {
        body.allUsers = false
        body.userIds = toRaw(selectedUsers.value)
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/send-multiple-time-reminder`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            console.log(response.data)
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

const removeUser = async (userId) => {

    if (!confirm('¿Estás segur@ de remover este colaborador de tu lista de autorizaciones?')) { return; }

    const body = { auth_id: decodedToken.value.user_id, user_id: userId }

    try {
        const response = await axios.post(`${API_BASE_URL}/remove-user-from-auth`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            alert(response.data.msg)
            getMyUsers()
            getNoTimeSentUsers()
            getNotAuthAbstract()
            getAuthAbstract()
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

onMounted(async () => {
    await getNoTimeSentUsers()
    await getAuthorizers()
    await getNotAuthAbstract()
    await getAuthAbstract()
    await getMyUsers()
});

</script>

<style scoped>
.table-responsive {
    overflow-x: auto;
}

.table-container {
    max-height: 600px;
    /* Ajusta la altura según necesites */
    overflow-y: auto;
    position: relative;
}

.sticky-header {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: white;
}

.sticky-header th {
    background-color: white;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

.justified-absence {
    background-color: #d1ecf1;
    font-weight: 500;
}

.justified-absence-indicator {
    background-color: #d1ecf1;
    width: 15px;
    height: 15px;
}
.pm-authorized {
    background-color: #d4edda;
    font-weight: 500;
}
</style>